import { render } from "./ProductDetail.vue?vue&type=template&id=f90b7d70"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=f90b7d70&lang=scss"
script.render = render

export default script